import { CategoriesStore } from '../schema/CategoriesStore';
import { getInitialCategoriesLookup } from '../api/getInitialCategoriesLookup';

const categoriesStore: CategoriesStore = {
    categoriesLookup: undefined,
};

/**
 * Get the categories store
 */
export const getCategoriesStore = () => {
    if (!categoriesStore.categoriesLookup) {
        categoriesStore.categoriesLookup = getInitialCategoriesLookup();
    }
    return categoriesStore;
};
